import { render, staticRenderFns } from "./ViewContentPanel.vue?vue&type=template&id=152f5b3c&"
import script from "./ViewContentPanel.vue?vue&type=script&lang=js&"
export * from "./ViewContentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports